module.exports = __webpack_public_path__ + "img/streak-badge.357a1c84.png";